import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { CandidateState } from "./types";
import CandidateService from "@/services/candidate.service";
import { AxiosError, AxiosResponse } from "axios";
import toast from "@/functions/toast.function";

const service: CandidateService = new CandidateService();

export const actions: ActionTree<CandidateState, RootState> = {
  login(_, callback: ActionCallback) {
    service
      .login(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  request(_, callback: ActionCallback) {
    service
      .request(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          toast.success("Success.");
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  reset(_, callback: ActionCallback) {
    service
      .reset(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          toast.success("Success.");
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
};
